import React, { useState, useEffect } from 'react';
import fondoImg from './fondo2.jpg';
import GestionEmpleados from './components/GestionEmpleados';
import { supabase } from './supabase';
import Mapa from './components/Mapa';
import FormularioTrabajo from './components/FormularioTrabajo';
import DetallesTrabajo from './components/DetallesTrabajo';
import Login from './components/Login';
import Menu from './components/Menu';
import Dashboard from './components/Dashboard';
import MiPerfil from './components/MiPerfil';
import Recibos from './components/Recibos';
import Capacitaciones from './components/Capacitaciones';
import OrganigramaView from './components/OrganigramaView';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import './App.css';
import MisRecibos from './components/MisRecibos';
registerLocale('es', es);

function App() {
  const [session, setSession] = useState(null);
  const [perfil, setPerfil] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [seccion, setSeccion] = useState('dashboard');
  const [trabajos, setTrabajos] = useState([]);
  const [secciones, setSecciones] = useState([]);
  const [trabajoSeleccionado, setTrabajoSeleccionado] = useState(null);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [filtros, setFiltros] = useState({ seccion: '', tipo: '', estado: '', fecha: null, busqueda: '' });

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) cargarPerfil(session.user.id);
      else setCargando(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session) cargarPerfil(session.user.id);
      else { setPerfil(null); setCargando(false); }
    });
    return () => subscription.unsubscribe();
  }, []);

  async function cargarPerfil(userId) {
    const { data } = await supabase.from('perfiles').select('*').eq('id', userId).single();
    setPerfil(data);
    setCargando(false);
  }

  useEffect(() => {
    if (session) cargarDatos();
  }, [session]);

  async function cargarDatos() {
    const { data: trabajosData } = await supabase.from('trabajos').select('*, secciones(nombre)');
    const { data: seccionesData } = await supabase.from('secciones').select('*');
    setTrabajos(trabajosData || []);
    setSecciones(seccionesData || []);
  }

  const trabajosFiltrados = trabajos.filter(t => {
    if (filtros.seccion && t.seccion_id !== parseInt(filtros.seccion)) return false;
    if (filtros.tipo && t.tipo !== filtros.tipo) return false;
    if (filtros.estado && t.estado !== filtros.estado) return false;
    if (filtros.fecha) {
      const fechaFiltro = filtros.fecha.toISOString().split('T')[0];
      if (t.fecha !== fechaFiltro) return false;
    }
    if (filtros.busqueda && !t.titulo.toLowerCase().includes(filtros.busqueda.toLowerCase())) return false;
    return true;
  });

  if (cargando) return <div className="mapa-cargando">Cargando...</div>;
  if (!session) return <Login />;

  const renderSeccion = () => {
    switch (seccion) {
      case 'dashboard': return <Dashboard perfil={perfil} />;
      case 'perfil': return <MiPerfil perfil={perfil} onActualizar={() => cargarPerfil(session.user.id)} />;
      case 'recibos': return <MisRecibos />;
      case 'admin-recibos': return <Recibos perfil={perfil} />;
      case 'capacitaciones': return <Capacitaciones perfil={perfil} />;
      case 'organigrama': return <OrganigramaView />;
      case 'mapa': return (
        <div className="mapa-seccion">
          <div className="filtros">
            <div className="filtro-item">
              <span>🗺️</span>
              <select onChange={e => setFiltros({...filtros, seccion: e.target.value})}>
                <option value="">Todas las provincias</option>
                {secciones.map(s => <option key={s.id} value={s.id}>{s.nombre}</option>)}
              </select>
            </div>
            <div className="filtro-item">
              <span>🔧</span>
              <select onChange={e => setFiltros({...filtros, tipo: e.target.value})}>
                <option value="">Todos los tipos</option>
                <option value="mantenimiento">Mantenimiento</option>
                <option value="reparacion">Reparación</option>
                <option value="inspeccion">Inspección</option>
                <option value="instalacion">Instalación</option>
              </select>
            </div>
            <div className="filtro-item">
              <span>✅</span>
              <select onChange={e => setFiltros({...filtros, estado: e.target.value})}>
                <option value="">Todos los estados</option>
                <option value="pendiente">Pendiente</option>
                <option value="en progreso">En progreso</option>
                <option value="finalizado">Finalizado</option>
              </select>
            </div>
            <div className="filtro-item">
              <span>📅</span>
              <DatePicker
                selected={filtros.fecha}
                onChange={date => setFiltros({...filtros, fecha: date})}
                locale="es"
                dateFormat="dd/MM/yyyy"
                placeholderText="Filtrar por fecha"
                isClearable
              />
            </div>
            <div className="filtro-item">
              <span>🔍</span>
              <input
                type="text"
                placeholder="Buscar obra..."
                onChange={e => setFiltros({...filtros, busqueda: e.target.value})}
                style={{ background: 'transparent', border: 'none', color: '#ccc', outline: 'none', fontSize: '0.88rem' }}
              />
            </div>
            <button className="btn-agregar" onClick={() => setMostrarFormulario(true)}>
              + Agregar Trabajo
            </button>
          </div>
          <div className="mapa-wrap">
            <Mapa trabajos={trabajosFiltrados} onSeleccionar={setTrabajoSeleccionado} />
            <div className="leyenda">
              <div className="leyenda-item"><span style={{background:'#f97316'}}></span> Mantenimiento</div>
              <div className="leyenda-item"><span style={{background:'#ef4444'}}></span> Reparación</div>
              <div className="leyenda-item"><span style={{background:'#3b82f6'}}></span> Inspección</div>
              <div className="leyenda-item"><span style={{background:'#22c55e'}}></span> Instalación</div>
              <div className="leyenda-sep"></div>
              <div className="leyenda-item">⏳ Pendiente</div>
              <div className="leyenda-item">🔄 En progreso</div>
              <div className="leyenda-item">✅ Finalizado</div>
            </div>
          </div>
        </div>
      );
      case 'admin-empleados': return <GestionEmpleados />;
      default: return <Dashboard perfil={perfil} />;
    }
  };

  return (
    <div className="app" style={{ backgroundImage: `url(${fondoImg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
      <Menu
        seccionActiva={seccion}
        onCambiarSeccion={setSeccion}
        perfil={perfil}
        onCerrarSesion={() => supabase.auth.signOut()}
      />

      <div className="contenido-principal">
        {renderSeccion()}
      </div>

      {trabajoSeleccionado && (
        <DetallesTrabajo
          trabajo={trabajoSeleccionado}
          onCerrar={() => setTrabajoSeleccionado(null)}
          onActualizar={cargarDatos}
        />
      )}

      {mostrarFormulario && (
        <FormularioTrabajo
          secciones={secciones}
          session={session}
          onCerrar={() => setMostrarFormulario(false)}
          onGuardado={() => { cargarDatos(); setMostrarFormulario(false); }}
        />
      )}
    </div>
  );
}

export default App;